var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnAssignTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8875 20.7062L21.675 16.4812C22.475 16.7562 23.2125 17.0812 23.8875 17.4312C25.1 18.0687 25.8625 19.3312 25.8875 20.7062ZM27.375 25.7312L25.6125 27.4937L22.35 24.2437H5.8875V20.7687C5.8875 19.3687 6.65 18.0812 7.9 17.4437C9.5125 16.6187 11.4875 15.9187 13.7375 15.6312L2.625 4.51873L4.3875 2.75623L27.375 25.7312ZM19.85 21.7437L16.1 17.9937C16.025 17.9937 15.9625 17.9937 15.8875 17.9937C12.925 17.9937 10.525 18.9062 9.0375 19.6687C8.6375 19.8687 8.3875 20.2937 8.3875 20.7687V21.7437H19.85ZM15.8875 6.74373C17.2625 6.74373 18.3875 7.86873 18.3875 9.24373C18.3875 10.3187 17.7125 11.2312 16.7625 11.5812L18.6125 13.4312C19.9875 12.5437 20.8875 10.9937 20.8875 9.24373C20.8875 6.48123 18.65 4.24373 15.8875 4.24373C14.1375 4.24373 12.5875 5.14373 11.7 6.51873L13.55 8.36873C13.9 7.41873 14.8125 6.74373 15.8875 6.74373Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnAssignTickets);
export default __webpack_public_path__ + "static/media/Un-Assign Tickets.7d4f6fdaae5d79fe1330b507e73b0db7.svg";
export { ForwardRef as ReactComponent };